import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";

export const identificationFilesMagicLinkApiKey = "identificationFilesMagicLinkApi";
export const identificationFilesMagicLinkApi = createApi({
  reducerPath: identificationFilesMagicLinkApiKey,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    getIdentificationFileUploadTokenMagicLink: builder.query<{ uploadIdToken: string }, string>({
      query: (token) => ({
        url: "/identification-files-magic-link/upload-token",
        headers: { [httpHeaders.magicToken]: token },
      }),
    }),
  }),
});

export const { useLazyGetIdentificationFileUploadTokenMagicLinkQuery } = identificationFilesMagicLinkApi;
